// src/Auth.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { getStoredAdmin, getStoredToken } from './config/api';

export function RequireAuth({ children }) {
  const admin = getStoredAdmin();
  const token = getStoredToken();
  return admin && token ? children : <Navigate to="/login" replace />;
}

export function useAdmin() {
  return getStoredAdmin();
}
